import React from "react";

const ErrorTekst = (props) => {

    const code = props.errorCode;
    const search = props.search;

    return (
        <>
            { code === 403 && (search === null || search === undefined ) && <ErrorAdgangTekst /> }
            { code === 403 && search === true && <ErrorAdgangOppgraderTekst /> }
            { code !== 403 && <ErrorGenerellTekst /> }
        </>
    );

}

const ErrorAdgangTekst = () => {
    return (
        <>
            <strong>Søgning i Hundedatabasen og Update kan lade sig gøre med et sølv- eller guldmedlemskab</strong><br />
            Du kan indmelde dig via punktet <a href={process.env.REACT_APP_HUNDEWEB_ENDPOINT + `/secure/openPage/innmelding/bliv-medlem-medlemstyper.html`}>Bliv medlem</a><br />
            Er du allerede sølv- eller guldmedlem mangler du at tilknytte dit medlemsnummer til din profil. Medlemsnummer og pinkode finder du i din velkomstmail.
            <a href={process.env.REACT_APP_HUNDEWEB_ENDPOINT + `/secure/openPage/et_reg/PEID_reg.html`}> Tilknyt her</a>

            <br />
            <br />
            <a href={process.env.REACT_APP_API_ENDPOINT + `/j_spring_cas_security_logout`}>

                <div className="menu-label">Log ud</div>

            </a>

        </>
    );
}



const ErrorGenerellTekst = () => {
    return (
        <>
            Vi opdaterer databasen. Prøv igen om lidt.
        </>
    );
}
const ErrorAdgangOppgraderTekst = () => {
    return (
        <>
            <br/>
            <strong>Søgning i Hundedatabasen og Update kan lade sig gøre med et sølv- eller guldmedlemskab</strong><br /><br />
            Opgrader dit medlemskab <a href={process.env.REACT_APP_HUNDEWEB_ENDPOINT + `/secure/openPage/minside/medlemskap-medlemstyper.html?oppgrader=true`}>her</a>

            <br />
            <br />


        </>
    );
}



export default ErrorTekst;